import { BaseContext } from '../../../../utils/basecontext';
import { UIComponentHandler,  UIDataModel } from '../../uicomponent';
import { UIComponentView } from '../../uicomponentview';
import { PlayerComponent } from '../playercomponent';
import { PlayerWithSeekbarView } from './playerwithseekbarview';

export class PlayerWithSeekbarComponent extends PlayerComponent 
{
    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new PlayerWithSeekbarView(applicationContext, uiComponentHandler);

    }
    
    componentDidMount()
    {
        (this.getView() as PlayerWithSeekbarView).resetControls();
        
    }
    
    componentWillUnmount() 
    {
        this.setState({isPlaying: false});

        (this.getView() as PlayerWithSeekbarView).unregisterAudioEvents();
        (this.getView() as PlayerWithSeekbarView).resetControls();
        this.getContext().getPlayerManager().release();
    }

    
     onPlayComplete(): void
    {
        (this.getView() as PlayerWithSeekbarView).resetControls();
        this.setState({isPlaying: false});
    } 
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/player/playerwithseekbar/playerwithseekbarcomponent.tsx